import { useCallback, useEffect, useState } from "react";

/**
 * Context on a click (TT-1174 note 5), for the live views whose board
 * links a line to its sentence: the sentence the transcript panel holds,
 * from a click until "Back to live" or the panel closes. The panel then
 * stays on that sentence while the playhead moves on.
 *
 * Returns the panel's `focus` / `onRelease` pair and the click handler to
 * give the canvas — stable, so a canvas that binds it once per mount
 * never remounts for it — or null when the host has no panel to open
 * (`onInfoOpenChange` absent), which leaves the board inert.
 */
export default function useTranscriptFocus(infoOpen, onInfoOpenChange) {
  const [focus, setFocus] = useState(null);
  const onSentClick = useCallback(
    (sent) => {
      setFocus(sent);
      onInfoOpenChange?.(true);
    },
    [onInfoOpenChange]
  );
  const onRelease = useCallback(() => setFocus(null), []);
  useEffect(() => {
    if (!infoOpen) setFocus(null);
  }, [infoOpen]);
  return { focus, onRelease, onSentClick: onInfoOpenChange ? onSentClick : null };
}
